import { render, staticRenderFns } from "./scopecenter3.vue?vue&type=template&id=4f6df3cf&scoped=true"
import script from "./scopecenter3.vue?vue&type=script&lang=js"
export * from "./scopecenter3.vue?vue&type=script&lang=js"
import style0 from "./scopecenter3.vue?vue&type=style&index=0&id=4f6df3cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6df3cf",
  null
  
)

export default component.exports